export default class CartItem
{
  constructor(productId, quantity, customFields) 
  {
    this.productId = productId;
    this.quantity = quantity;
    this.customFields = customFields;
  }    
}